import { useState, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Contract from "./pages/Contract";
import Loan from "./pages/ContractBrowser";
import SecMaster from "./pages/SecMaster";
import CounterParty from "./pages/CounterParty";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Layout from "./components/Layout";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { store } from "./redux/store";
import { useNavigate, useLocation } from "react-router-dom";
import DtcDashboard from "./pages/DtcDashboard";
import RiskByCpty from "./pages/risk/risk-by-cpty/index";

import _ from "lodash";

//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";

//core
import "primereact/resources/primereact.min.css";

//icons
import "primeicons/primeicons.css";
import LoanReturns from "./pages/LoanReturns";
import AccessDenied from "./pages/AccessDenied";
import {
  contractBrowserRoles,
  cptyRoles,
  dtcRoles,
  loanReturnsRoles,
  locateDashboardRole,
  ratesDashboardRoles,
  secmasterRoles,
  slQuoteRoles,
  supplyManagementRole,
  tradeRoles,
  slDeskEODSummaryRoles,
  userManagementRoles,
  pageConstant,
} from "./config/pageConstant";
import Recalls from "./pages/Recalls";
import RatesDashboard from "./pages/RatesDashboard";
import { hasAccess } from "./common/commonFunctions";
import SupplyManagement from "./pages/SupplyManagement";
import LocateDashboard from "./pages/LocateDashboard";
import SLQuote from "./pages/Dashboards/SLQuote";
import EODSummary from "./pages/Dashboards/EODSummary";
import ChangePassword from "./pages/ChangePassword";
import LocatePNL from "./pages/LocatePNL";
import LocateClient from "./pages/LocatesClient";
import LiquidityRiskDashboard from "./pages/risk/liquidity-risk-dashboard";

const NO_AUTH = ["/signin"];

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isInit, setIsInit] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  var isUserActive: any = window.localStorage.getItem("authenticated");

  useEffect(() => {
    if (!isInit) {
      const currentUser = store.getState().user;
      setIsUserLoggedIn(currentUser?.userName);
      setIsInit(true);
    }
  }, [isInit]);

  const validateAuth = async () => {
    window.scrollTo(0, 0);
    if (
      isUserActive == null ||
      isUserActive === false ||
      isUserActive !== "true"
    ) {
      navigate("/signin");
    } else if (isUserActive === true) {
      navigate("/trading/contract");
    }
  };
  useEffect(() => {}, [isUserLoggedIn]);

  const validateNoAuth = async () => {
    window.scrollTo(0, 0);
    if (isUserLoggedIn === true) {
    }
  };
  useEffect(() => {
    // CALL: when route change or initialize complete
    if (isInit) {
      const noAuthPath = NO_AUTH.filter((path: any) => {
        return location.pathname.indexOf(path) > -1;
      });
      if (noAuthPath.length > 0) {
        validateNoAuth();
      } else {
        const currentUser = store.getState().user;
        setIsUserLoggedIn(currentUser.userName);
        validateAuth();
      }
    }
  }, [location, isInit]);

  const isUserAuthorized = () => {
    let userName = window.localStorage.getItem("username");
    return (
      !_.isEmpty(userName) && !_.isUndefined(userName) && !_.isNull(userName)
    );
  };

  return (
    <div className="font-family">
      <div style={{ padding: "0px" }}>
        <Routes>
          <Route path="/signin" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/" element={isUserAuthorized() ? <Layout /> : <Login />}>
            <Route
              path="/access-denied"
              element={isUserAuthorized() ? <AccessDenied /> : <Login />}
            />
            <Route
              path="/"
              element={
                isUserAuthorized() ? (
                  hasAccess(tradeRoles) ? (
                    <Contract />
                  ) : (
                    <AccessDenied requestedURL={"Trade Booking"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/change-password"
              element={
                isUserAuthorized() ? (
                  hasAccess(userManagementRoles) ? (
                    <ChangePassword />
                  ) : (
                    <AccessDenied requestedURL={"Change Password"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/dashboards/sl-quote/:ticker_in"
              element={
                isUserAuthorized() ? (
                  hasAccess(slQuoteRoles) ? (
                    <SLQuote />
                  ) : (
                    <AccessDenied requestedURL={"SL Quote"} />
                  )
                ) : (
                  <Login />
                )
              }
            ></Route>
            <Route
              path="/dashboards/eod-summary"
              element={
                isUserAuthorized() ? (
                  hasAccess(slDeskEODSummaryRoles) ? (
                    <EODSummary />
                  ) : (
                    <AccessDenied requestedURL={"EOD Summary Dashboard"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/trading/contract"
              element={
                isUserAuthorized() ? (
                  hasAccess(tradeRoles) ? (
                    <Contract />
                  ) : (
                    <AccessDenied requestedURL={"Trade Booking"} />
                  )
                ) : (
                  <Login />
                )
              }
            />
            <Route
              path="/trading/contract-browser"
              element={
                isUserAuthorized() ? (
                  hasAccess(contractBrowserRoles) ? (
                    <Loan />
                  ) : (
                    <AccessDenied requestedURL={"Contract Browser"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/operations/dtc-dashboard"
              element={
                isUserAuthorized() ? (
                  hasAccess(dtcRoles) ? (
                    <DtcDashboard />
                  ) : (
                    <AccessDenied requestedURL={"DTC Dashboard"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/operations/callbacks"
              element={
                isUserAuthorized() ? (
                  hasAccess(loanReturnsRoles) ? (
                    <LoanReturns />
                  ) : (
                    <AccessDenied requestedURL={"Callbacks"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/operations/recalls"
              element={
                isUserAuthorized() ? (
                  hasAccess(loanReturnsRoles) ? (
                    <Recalls />
                  ) : (
                    <AccessDenied requestedURL={"Recalls"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/reference-data/sec-master"
              element={
                isUserAuthorized() ? (
                  hasAccess(secmasterRoles) ? (
                    <SecMaster />
                  ) : (
                    <AccessDenied requestedURL={"Sec Master"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/reference-data/counter-party"
              element={
                isUserAuthorized() ? (
                  hasAccess(cptyRoles) ? (
                    <CounterParty />
                  ) : (
                    <AccessDenied requestedURL={"Cpty Master"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/locates/locates-dashboard"
              element={
                isUserAuthorized() ? (
                  hasAccess(locateDashboardRole) ? (
                    <LocateDashboard />
                  ) : (
                    <AccessDenied requestedURL={"Locates Dashboard"} />
                  )
                ) : (
                  <Login />
                )
              }
            />
            <Route
              path="/locates/rates-dashboard"
              element={
                isUserAuthorized() ? (
                  hasAccess(ratesDashboardRoles) ? (
                    <RatesDashboard />
                  ) : (
                    <AccessDenied requestedURL={"Rates Dashboard"} />
                  )
                ) : (
                  <Login />
                )
              }
            />
            <Route
              path="/locates/supply-management"
              element={
                isUserAuthorized() ? (
                  hasAccess(supplyManagementRole) ? (
                    <SupplyManagement />
                  ) : (
                    <AccessDenied requestedURL={"Supply Management"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/locates/locates-pnl"
              element={
                isUserAuthorized() ? (
                  hasAccess([
                    `${pageConstant.LOCATE_DASHBOARD}_ADMIN`,
                    `${pageConstant.LOCATE_DASHBOARD}_RO`,
                  ]) ? (
                    <LocatePNL />
                  ) : (
                    <AccessDenied requestedURL={"Locates PNL"} />
                  )
                ) : (
                  <Login />
                )
              }
            />
            <Route
              path="/locates/locates-client"
              element={
                isUserAuthorized() ? (
                  !hasAccess([
                    `${pageConstant.LOCATE_DASHBOARD}_ADMIN`,
                    `${pageConstant.LOCATE_DASHBOARD}_RW`,
                    `${pageConstant.LOCATE_DASHBOARD}_RO`,
                  ]) &&
                  hasAccess([
                    `${pageConstant.LOCATE_CLIENT}_ADMIN`,
                    `${pageConstant.LOCATE_CLIENT}_RO`,
                  ]) ? (
                    <LocateClient />
                  ) : (
                    <AccessDenied requestedURL={"Locates LOCATE_CLIENT"} />
                  )
                ) : (
                  <Login />
                )
              }
            />

            {/* old Routes */}
            <Route
              path="/sl-quote/:ticker_in"
              element={
                <Navigate to="/dashboards/sl-quote/:ticker_in" replace />
              }
            ></Route>
            <Route
              path="/eod-summary"
              element={<Navigate to="/dashboards/eod-summary" replace />}
            />

            <Route
              path="/contract"
              element={<Navigate to="/trading/contract" replace />}
            />
            <Route
              path="/contract-browser"
              element={<Navigate to="/trading/contract-browser" replace />}
            />

            <Route
              path="/dtc-dashboard"
              element={<Navigate to="/operations/dtc-dashboard" replace />}
            />

            <Route
              path="/callbacks"
              element={<Navigate to="/operations/callbacks" replace />}
            />

            <Route
              path="/recalls"
              element={<Navigate to="/operations/recalls" replace />}
            />

            <Route
              path="/sec-master"
              element={<Navigate to="/reference-data/sec-master" replace />}
            />

            <Route
              path="/counter-party"
              element={<Navigate to="/reference-data/counter-party" replace />}
            />

            <Route
              path="/locates-dashboard"
              element={<Navigate to="locates/locates-dashboard" replace />}
            />
            <Route
              path="/rates-dashboard"
              element={<Navigate to="locates/rates-dashboard" replace />}
            />
            <Route
              path="/supply-management"
              element={<Navigate to="locates/supply-management" replace />}
            />

            <Route
              path="/locates-pnl"
              element={<Navigate to="locates/locates-pnl" replace />}
            />
            <Route
              path="/locates-client"
              element={<Navigate to="locates/locates-client" replace />}
            />
           
            <Route
              path="/risk/risk-by-cpty"
              element={isUserAuthorized() ? <RiskByCpty /> : <Login />}
            />

             <Route
              path="/risk/liquidity-risk-dashboard"
              element={isUserAuthorized() ? <LiquidityRiskDashboard /> : <Login />}
            />
 
            {/* old Routes */}
          </Route>
        </Routes>
      </div>
    </div>
  );
}

export default App;
